import { useStore } from 'jotai';
import { useCallback } from 'react';

import { isCommandMenuOpenState } from '@/command-menu/states/isCommandMenuOpenState';

export const useOpenCommandMenu = () => {
  const store = useStore();

  const openCommandMenu = useCallback(() => {
    store.set(isCommandMenuOpenState.atom, true);
  }, [store]);

  return { openCommandMenu };
};
